<template>
  <div class="attribute_group_page">
    <h3 class="title-page">{{ $t("attributes") }}</h3>
    <div>
      <div class="admin_container">
        <div class="mdm_main">
          <div>
            <v-btn
              class="mb-3 ml-auto"
              style="display: block"
              color="primary"
              dark
              min-height="38"
              @click="dialog = true"
            >
              <!--              <v-icon left dark>mdi-plus</v-icon>-->
              {{ $t("create") }}
            </v-btn>
          </div>
          <div>
            <table-with-filter
              fixed-header
              :headers="headers"
              handler-value="name"
              child-key="items"
              :items.sync="attributes"
              :page="configuration.page"
            >
              <template #filter.name>
                <div class="pa-1">
                  <custom-input-text
                    @input="getAttributeByFilter"
                    v-model="configuration.name"
                    class="user_input no-margin"
                    clearable
                  />
                </div>
              </template>

              <template #item.action="{ item }">
                <div v-if="!item.parent_id">
                  <v-tooltip nudge-top="35" nudge-right="10" color="#fff" left>
                    <template v-slot:activator="{ on, attrs }">
                      <!--If you add to 'btn_33' element 'disabled' class. it is disabled element  -->
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="new_style"
                        @click="editAttribute(item)"
                      >
                        <vue-icon icon="newPencilIcon" />
                      </v-btn>
                    </template>
                    <span>{{ $t("edit") }}</span>
                  </v-tooltip>
                  <v-tooltip nudge-top="35" nudge-right="10" color="#fff" left>
                    <template v-slot:activator="{ on, attrs }">
                      <!--If you add to 'btn_33' element 'disabled' class. it is disabled element  -->
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="new_style"
                        @click="deleteAttribute(item)"
                      >
                        <vue-icon icon="newTrashIcon" />
                      </v-btn>
                    </template>
                    <span>{{ $t("delete") }}</span>
                  </v-tooltip>
                </div>
              </template>

              <template
                #expandBtn="{ item, header, handlerValue, openHandler }"
              >
                <triangle-btn
                  v-if="!item.parent_id && header.value === handlerValue"
                  :active="item.show"
                  :loading="item.loading"
                  @click="openHandler(item)"
                ></triangle-btn>
              </template>
              <template #child.value="{ child }">
                {{ child }}
              </template>
            </table-with-filter>

            <vue-pagination
              @update:limit="
                (limit) => {
                  configuration.limit = limit;
                  configuration.page = 1;
                  changePage();
                }
              "
              v-model="configuration.page"
              :length="lastPage"
              @input="changePage"
              max-page
              :limit="configuration.limit"
            />
          </div>
        </div>
      </div>
    </div>

    <v-dialog
      v-model="dialog"
      @click:outside="dialog = false"
      persistent
      max-width="528"
      class="user_modal_dialog"
    >
      <v-card>
        <validation-observer v-slot="{ handleSubmit }" ref="attributeForm">
          <v-form @submit.prevent="handleSubmit(saveAttribute)">
            <v-card-title class="mb-5">
              <span class="headline title_modal_user">{{ formTitle }}</span>
              <v-icon @click="dialog = false" class="info_modal_close"
                >mdi-close</v-icon
              >
            </v-card-title>
            <v-card-text class="main_modal">
              <v-container class="pa-0 user_modal_form">
                <div
                  class="mb-5 mt-7 row align-center user_modal_form_inner ml-0 after_border"
                >
                  <label class="col-md-6 pa-0"
                    >{{ $t("nameAttribute") }}*</label
                  >
                  <custom-input-text
                    rules="required"
                    :name="$t('nameAttribute')"
                    v-model="attributeFormData.name"
                    class="col-md-6 pa-0 user_input"
                    :placeholder="$t('material')"
                  ></custom-input-text>
                </div>
                <div
                  class="mb-5 mt-7 row align-center user_modal_form_inner ml-0"
                >
                  <label class="col-md-6 pa-0">{{ $t("value") }}</label>
                  <custom-input-text
                    v-model="attrValue"
                    class="col-md-6 pa-0 user_input"
                    :placeholder="$t('enterValue')"
                  >
                    <template #append>
                      <v-btn
                        :disabled="attrValue.trim() === ''"
                        @click="addValue"
                        class="btn_input_append"
                        >+
                      </v-btn>
                    </template>
                  </custom-input-text>
                </div>
                <div
                  class="flex-wrap d-flex file_modal_container after_border mb-6"
                >
                  <div
                    v-for="(value, index) in attributeFormData.items"
                    :key="`value-${index}`"
                    class="file_modal_item_wrap"
                  >
                    <div class="file_modal_item">
                      {{ value }}
                      <v-btn icon @click="deleteValue(value)">
                        <v-icon class="file_close_icon">mdi-close</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </div>
              </v-container>
            </v-card-text>
            <v-card-actions class="footer_modal_user">
              <div class="row">
                <div
                  class="d-flex flex-wrap justify-space-around button_modal_add mr-3 mt-3"
                >
                  <v-btn color="primary" type="submit">{{ $t("save") }}</v-btn>
                </div>
              </div>
            </v-card-actions>
          </v-form>
        </validation-observer>
      </v-card>
    </v-dialog>
    <warning-dialog
      @apply="deleteAttributeHandler"
      v-model="confirmDialog"
    ></warning-dialog>
  </div>
</template>

<script>
import triangleBtn from "@/components/table-with-children/triangleBtn";
import WarningDialog from "@/components/ui/prompt/warning-dialog";
import TableWithFilter from "@/components/ui/table/TableWithFilter";
import VuePagination from "@/components/ui/vue-pagination/VuePagination";
import { debounce, getQueryByKey } from "@/utils/pureFunctions";

export default {
  name: "attribute-reference",
  data() {
    return {
      confirmDialog: false,
      dialog: false,
      attributes: [],
      attrValue: "",
      attributeFormData: {
        name: "",
        items: [],
      },
      configuration: {
        limit: "50",
        page: 1,
        name: null,
      },
      lastPage: 0,
    };
  },
  computed: {
    isEditingNewAttribute() {
      return !this.attributeFormData.id;
    },
    formTitle() {
      return this.isEditingNewAttribute
        ? this.$t("addAttribute")
        : this.$t("editGroup");
    },
    headers() {
      return [
        {
          text: this.$t("attributes"),
          value: "name",
        },
        {
          text: this.$t("value"),
          value: "value",
        },
        {
          text: this.$t("action"),
          value: "action",
        },
      ];
    },
  },
  watch: {
    confirmDialog(val) {
      if (!val) this.clearAttributeForm();
    },
    dialog(val) {
      if (!val) this.clearAttributeForm();
    },
  },
  methods: {
    clearAttributeForm() {
      this.$refs.attributeForm.reset();
      this.attrValue = "";
      this.attributeFormData = {
        name: "",
        items: [],
      };
    },
    deleteAttributeHandler() {
      this.$http
        .delete("attributes/delete?id=" + this.attributeFormData.id)
        .then(() => {
          this.getAttributes();
          this.setSuccess({ text: this.$t("successfullySaved") });
        });
    },
    deleteAttribute(item) {
      this.confirmDialog = true;
      this.attributeFormData = {
        id: item.id,
        name: item.name,
        items: [...item.items],
      };
    },
    editAttribute(item) {
      this.dialog = true;
      this.attributeFormData = {
        id: item.id,
        name: item.name,
        items: [...item.items],
      };
    },
    async saveAttribute() {
      this.showLoading();
      try {
        const {
          data: { data },
        } = await this.$http.post("attributes/save", this.attributeFormData);
        if (this.isEditingNewAttribute) {
          data.show = false;
          this.attributes.push(data);
        } else {
          const attribute = this.attributes.find((item) => item.id === data.id);
          if (attribute) {
            attribute.items = data.items;
          }
        }
        await this.getAttributes();
        this.setSuccess({ text: this.$t("successfullySaved") });
        this.dialog = false;
        this.clearAttributeForm();
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    deleteValue(title) {
      this.attributeFormData.items = this.attributeFormData.items.filter(
        (item) => {
          return item !== title;
        }
      );
    },
    addValue() {
      this.attributeFormData.items.push(this.attrValue);
      this.attrValue = "";
    },
    getAttributeByFilter: debounce(function () {
      this.$router.replace({ query: { ...this.configuration } });
      this.getAttributes();
    }, 300),
    changePage() {
      this.$router.replace({ query: { ...this.configuration } });
      this.getAttributes();
    },
    async getAttributes() {
      this.showLoading();
      try {
        let params = {
          ...this.configuration,
          page: this.configuration.page - 1,
        };
        const { data, lastPage } = await this.$store.dispatch(
          "getAttributes",
          params
        );
        this.lastPage = lastPage;
        this.attributes = data;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
  },
  components: { VuePagination, TableWithFilter, WarningDialog, triangleBtn },
  mounted() {
    const options = getQueryByKey(this.configuration, this.$route.query);
    if (options.page && !isNaN(options.page)) options.page = +options.page;
    this.configuration = options;
    this.getAttributes();
  },
};
</script>

<style scoped></style>
